module.exports = __webpack_public_path__ + "img/feature1.af9cc5b9.jpg";